/* eslint-disable no-console */
/* eslint-disable no-param-reassign */

import { isDevelopment } from '../../utils';

/* eslint-disable no-underscore-dangle */
export class ConnectWiseHostedAPI {
  constructor(origin, handlers = {}, debug) {
    this.version = '1.0';
    this._debug = debug;
    this._origin = origin;
    this._frameID = null;
    this._callbacks = {};

    // callback listener
    (handlers.eventHandlers || []).forEach(handler => {
      this._callbacks[`${handler.event}`] = handler.callback;
    });
  }

  messageReceiver = e => {
    this.log(`received message:`, e.data);
    if (typeof e.data !== 'string' || e.data === '') {
      return;
    }

    let json = {};
    try {
      json = JSON.parse(e.data);
    } catch (err) {
      this.log(`failed to parese message:`, e.data);
      return;
    }
    if (json.MessageFrameID) {
      this.log(`setting frameID to ${json.MessageFrameID}`);
      this._frameID = json.MessageFrameID;
      return;
    }

    if (json.response) {
      if (this._callbacks[json.response]) {
        this._callbacks[json.response](json.data);
        this._callbacks[json.response] = null;
      }
      return;
    }

    if (json.event && this._callbacks[json.event]) {
      json.data.onSuccess = () => {
        this._postMessage({ event: json.event, _id: json._id, result: 'success' });
      };

      json.data.onFailure = data => {
        this._postMessage({ event: json.event, _id: json._id, result: 'failure', errors: data });
      };

      this._callbacks[json.event](json.data);
    } else if (json.event) {
      this._postMessage({ event: json.event, _id: json._id, result: 'success' });
    }
  };

  initialize() {
    if (window === window.parent) {
      this.log('No parent to send messages to or receive messages from');
      return;
    }
    window.addEventListener('message', this.messageReceiver, false);
    this._postMessage({ message: 'ready' });
  }

  post(message, callback) {
    if (window === window.parent) {
      this.log('No parent to send messages to or receive messages from');
      return;
    }
    if (typeof callback !== 'undefined') {
      this._callbacks[`${message.request.toLowerCase()}`] = callback;
    }

    // need to pre-pend hosted_ to request to avoid confusion with vendor hosted api.
    message.hosted_request = message.request;
    delete message.request;

    this._postMessage(message);
  }

  _postMessage(message) {
    if (this._frameID != null) {
      message.frameID = this._frameID;
    }

    this.log(`posting message ${JSON.stringify(message)}`, message);
    window.parent.postMessage(JSON.stringify(message), this._origin);
  }

  log(...args) {
    if (this._debug === true) {
      console.log(`ConnectWiseHostedAPI: `, ...args);
    }
  }
}

const connectwiseHostedAPI = new ConnectWiseHostedAPI(document.referrer, {}, isDevelopment());
export default connectwiseHostedAPI;
